<div class="content">
  <div class="content-panel">
    Vous allez être redirigé vers Agri Maker.
  </div>
</div>